var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE2Bedroom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 3.63L3 25.89V69h70V25.9L38 3.63zM69 65H7V28.08L38 8l31 20.08V65zM56 38a8.07 8.07 0 016.15 2.76A7.71 7.71 0 0164 45.85V46H25v-.15a7.91 7.91 0 011.78-5.07A7.62 7.62 0 0132 38h24zm-34.06 8H12v-9a10 10 0 017.68 3.53A9.86 9.86 0 0121.94 46zM12 49h52v10h-3v-7H15v7h-3V49z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E2_Bedroom.58074cab.svg";
export { SvgE2Bedroom as ReactComponent };